export const dataLayerEvents = {
    VIRTUAL_PAGE_VIEW: 'virtual_page_view',
    BOOKING: 'booking',
}